function CablesOrder({ yurtTrait, walls}) {
  return ( 
    <p>HELLO</p>
  )

}

export default CablesOrder